import { render, staticRenderFns } from "./beneficiary.vue?vue&type=template&id=1fdf13e6&scoped=true"
import script from "./beneficiary.vue?vue&type=script&lang=js"
export * from "./beneficiary.vue?vue&type=script&lang=js"
import style0 from "./beneficiary.vue?vue&type=style&index=0&id=1fdf13e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdf13e6",
  null
  
)

export default component.exports